"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _variable = _interopRequireDefault(require("./variable"));
var _GEHelper = require("../../graphicEngine/GEHelper");
var _GEDragHelper = require("../../graphicEngine/GEDragHelper");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2["default"])((0, _getPrototypeOf2["default"])(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
var SlideVariable = /*#__PURE__*/function (_Variable) {
  function SlideVariable(variable) {
    var _this;
    (0, _classCallCheck2["default"])(this, SlideVariable);
    Entry.assert(variable.variableType === 'slide', 'Invalid variable type given');
    _this = _callSuper(this, SlideVariable, [variable]);
    _this.setMinValue(variable.minValue);
    _this.setMaxValue(variable.maxValue);
    return _this;
  }
  (0, _inherits2["default"])(SlideVariable, _Variable);
  return (0, _createClass2["default"])(SlideVariable, [{
    key: "generateView",
    value: function generateView(variableIndex) {
      var _this2 = this;
      var slide = this;
      this.view_ = _GEHelper.GEHelper.newContainer();
      this.rect_ = _GEHelper.GEHelper.newGraphic();
      this.view_.addChild(this.rect_);
      this.view_.variable = this;
      this.view_.visible = this.visible_;
      this.view_.mouseEnabled = true;
      this.view_.mouseChildren = true;
      _GEDragHelper.GEDragHelper.handleDrag(this.view_);
      this.wrapper_ = _GEHelper.GEHelper.newGraphic();
      this.view_.addChild(this.wrapper_);
      this.textView_ = _GEHelper.GEHelper.textHelper.newText('name', this.FONT, '#000000', 'alphabetic');
      this.textView_.x = 4;
      if (_GEHelper.GEHelper.isWebGL) {
        this.textView_.y = this.GL_VAR_POS.LABEL_Y;
      } else {
        this.textView_.y = 1;
      }
      this.view_.addChild(this.textView_);
      this.valueView_ = _GEHelper.GEHelper.textHelper.newText('value', this.VALUE_FONT, '#ffffff', 'alphabetic');
      this.view_.on(_GEDragHelper.GEDragHelper.types.DOWN, function (evt) {
        if (Entry.type !== 'workspace') {
          return;
        }
        this.offset = {
          x: this.x - (evt.stageX * 0.75 - 240),
          y: this.y - (evt.stageY * 0.75 - 135)
        };
      });
      this.view_.on(_GEDragHelper.GEDragHelper.types.MOVE, function (evt) {
        if (Entry.type !== 'workspace' || slide.isAdjusting) {
          return;
        }
        this.variable.setX(evt.stageX * 0.75 - 240 + this.offset.x);
        this.variable.setY(evt.stageY * 0.75 - 135 + this.offset.y);
        this.variable.updateView();
      });
      this.view_.addChild(this.valueView_);
      var width = this.textView_.getMeasuredWidth() + this.valueView_.getMeasuredWidth() + 26;
      width = Math.max(width, 90);
      this.maxWidth = width - 20;
      this.slideBar_ = _GEHelper.GEHelper.newGraphic();
      this.slideBar_.graphics.beginFill('#d8d8d8').s('#d8d8d8').ss(1).rr(10, 10, this.maxWidth, 15, 4);
      this.slideBar_.mouseEnabled = true;
      _GEDragHelper.GEDragHelper.handleDrag(this.slideBar_);
      this.slideBar_.on(_GEDragHelper.GEDragHelper.types.DOWN, function (evt) {
        if (!Entry.engine.isState('run')) {
          return;
        }
        var value = evt.stageX * 0.75 - (_this2.getX() + 240 + 5) + 5;
        slide.setSlideCommandX(value);
      });
      this.view_.addChild(this.slideBar_);
      var position = this.getSlidePosition(this.maxWidth);
      var _ref = EntryStatic.images || {},
        stage_variable_slider = _ref.stage_variable_slider;
      this.valueSetter_ = _GEHelper.GEHelper.newSpriteWithCallback(stage_variable_slider || "".concat(Entry.mediaFilePath, "stage_variable_slider.png"), function () {
        Entry.requestUpdate = true;
      });
      this.valueSetter_.cursor = 'pointer';
      this.valueSetter_.scaleX = 0.8;
      this.valueSetter_.scaleY = 0.8;
      this.valueSetter_.mouseEnabled = true;
      this.valueSetter_.y = 9;
      this.valueSetter_.regX = 0.5;
      _GEDragHelper.GEDragHelper.handleDrag(this.valueSetter_);
      this.valueSetter_.on(_GEDragHelper.GEDragHelper.types.DOWN, function (evt) {
        if (!Entry.engine.isState('run')) {
          return;
        }
        slide.isAdjusting = true;
        this.offsetX = evt.stageX * 0.75 - this.x;
      });
      this.valueSetter_.on(_GEDragHelper.GEDragHelper.types.MOVE, function (evt) {
        if (!Entry.engine.isState('run')) {
          return;
        }
        var value = evt.stageX * 0.75 - this.offsetX + 5;
        //박봉배 - value 값의 min/max 는 다른곳에서 체크 하므로, 이곳에서는 로직 삭제 하겠음.
        slide.setSlideCommandX(value);
      });
      this.valueSetter_.on(_GEDragHelper.GEDragHelper.types.UP, function () {
        slide.isAdjusting = false;
      });
      this.view_.addChild(this.valueSetter_);
      var variableLength = Entry.variableContainer.variables_.length;
      if (this.getX() && this.getY()) {
        this.setX(this.getX());
        this.setY(this.getY());
      } else {
        this.setX(10 - 240 + Math.floor(variableLength / 11) * 80);
        this.setY(variableIndex * 24 + 20 - 135 - Math.floor(variableLength / 11) * 264);
      }
      this.setVisible(this.isVisible());
      Entry.stage.loadVariable(this);
    }
  }, {
    key: "updateView",
    value: function updateView() {
      if (!this.view_) {
        return;
      }
      if (this.isVisible()) {
        this._adjustSingleViewPosition();
        var oldContent = this.textView_.text;
        var newContent;
        if (this.object_) {
          var obj = Entry.container.getObject(this.object_);
          if (obj) {
            newContent = "".concat(obj.name, ":").concat(this.getName());
          } else {
            newContent = this.getName();
          }
        } else {
          newContent = this.getName();
        }
        if (oldContent !== newContent) {
          this.textView_.text = newContent;
          this._nameWidth = null;
        }
        if (this._nameWidth === null) {
          this._nameWidth = this.textView_.getMeasuredWidth();
        }
        this._adjustSingleValueViewPosition();
        var value = String(this.getValue());
        if (this.isFloatPoint()) {
          var reg = /\.(.*)/;

          //check the value is float
          var ret = reg.exec(value);
          if (!ret) {
            value += '.00';
          } else {
            while (reg.exec(value)[1].length < 2) {
              value += '0';
            }
          }
        }
        this.valueView_.text = value;
        if (this._valueWidth === null) {
          this._valueWidth = this.valueView_.getMeasuredWidth();
        }
        var width = this._nameWidth + this._valueWidth + 35;
        var colorSet = EntryStatic.colorSet.canvas || {};
        width = Math.max(width, 90);
        this.rect_.graphics.clear().f('#ffffff').ss(1, 2, 0).s(colorSet.border || '#aac5d5').rr(0, -14, width, 42, 4);
        this.wrapper_.graphics.clear().f(colorSet.slideVariable || '#4f80ff').ss(1, 2, 0).s(colorSet.slideVariable || '#4f80ff').rr(this._nameWidth + 14, -10, this._valueWidth + 15, 16, this.RECT_RADIUS);
        width = this._nameWidth + this._valueWidth + 26;
        width = Math.max(width, 90);
        this.maxWidth = width - 16;
        this.slideBar_.graphics.clear().beginFill('#d8d8d8').s('#d8d8d8').ss(1).rr(6, 16, this.maxWidth + 4, 5, 2);
        this.valueSetter_.x = this.getSlidePosition(this.maxWidth);

        // this.valueSetter_.graphics
        //     .clear()
        //     .beginFill('#1bafea')
        //     .s('#A0A1A1')
        //     .ss(1)
        //     .dc(position, 10 + 0.5, 3);
      }
      Entry.requestUpdate = true;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = _superPropGet(SlideVariable, "getValue", this, 3)([]);
      if (this.isNumber()) {
        return Number(value);
      } else {
        return value;
      }
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      var numValue = Number(value);
      if (numValue < this.minValue_) {
        this.value_ = this.minValue_;
      } else if (numValue > this.maxValue_) {
        this.value_ = this.maxValue_;
      } else {
        this.value_ = numValue;
      }
      _superPropGet(SlideVariable, "setValue", this, 3)([this.value_]);
    }
  }, {
    key: "setSlideCommandX",
    value: function setSlideCommandX(value) {
      if (!this.valueSetter_.command) {
        this.valueSetter_.command = {};
      }
      var commandX = typeof value === 'undefined' ? 10 : value;
      commandX = Math.max(commandX, 10);
      commandX = Math.min(this.maxWidth + 10, commandX);
      this.valueSetter_.command.x = commandX;
      this.updateSlideValueByView();
    }
  }, {
    key: "updateSlideValueByView",
    value: function updateSlideValueByView() {
      var maxWidth = this.maxWidth;
      var position = Math.max(this.valueSetter_.command.x - 10, 0);
      var ratio = position / maxWidth;
      if (ratio < 0) {
        ratio = 0;
      }
      if (ratio > 1) {
        ratio = 1;
      }
      var minValue = parseFloat(this.minValue_);
      var maxValue = parseFloat(this.maxValue_);
      var value = (minValue + Number(Math.abs(maxValue - minValue) * ratio)).toFixed(2);
      value = parseFloat(value);
      if (value < minValue) {
        value = this.minValue_;
      } else if (value > maxValue) {
        value = this.maxValue_;
      }
      if (!this.isFloatPoint()) {
        value = Math.round(value);
      }
      this.setValue(value);
    }
  }, {
    key: "getSlidePosition",
    value: function getSlidePosition(width) {
      var minValue = this.minValue_;
      var maxValue = this.maxValue_;
      var value = this.value_;
      var ratio = Math.abs(value - minValue) / Math.abs(maxValue - minValue);
      return width * ratio + 6;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = _superPropGet(SlideVariable, "toJSON", this, 3)([]);
      json.minValue = this.minValue_;
      json.maxValue = this.maxValue_;
      return json;
    }
  }]);
}(_variable["default"]);
var _default = exports["default"] = SlideVariable;